import React, { useEffect, useState } from 'react';
import {
  postEvaluationDetailsData,
  postQuestionPaperData,
  postSeatingPlanData,
  postInvigilator_s2_Data,
  postStudentStatusData,
} from './apiServices';
/* EVALUATION */
export const sendMailEvaluation = () => {
  const payload2 = [
    {
      sendEmail: true,
      subject: 'Test Subj',
      body: 'Test Subj',
      toAddresses: 'test@123.com,test@345.com',
    },
  ];

  postEvaluationDetailsData(payload2)
    .then((res) => {
      console.log('response send mail', res);
    })
    .catch((err) => {
      console.log('Error', err);
    });
  return console.log('send mail box');
};


/* QUESTION PAPER VIEW */
export const sendMailQuestion = () => {
  const payload2 = [
    {
      sendEmail: true,
      subject: 'Test Subj',
      body: 'Test Subj',
      toAddresses: 'test@123.com,test@345.com',
    },
  ];

  postQuestionPaperData(payload2)
    .then((res) => {
      console.log('response send mail', res);
    })
    .catch((err) => {
      console.log('Error', err);
    });
  return console.log('send mail box');
};


// Exam Time Table Data
export const sendMailSeatingPlan = (data) => {
  const payload2 = [
    {
      id: data,
      sendEmail: true,
      subject: 'Test Subj',
      body: 'Test Subj',
    },
  ];

  postSeatingPlanData(payload2)
    .then((res) => {
      console.log('response send mail', res);
    })
    .catch((err) => {
      console.log('Error', err);
    });
  return console.log('send mail box');
};


/* INVIGILATION AND PROCTORING */
export const sendMailInvigilator = () => {
  const payload2 = [
    {
      sendEmail: true,
      subject: 'Test Subj',
      body: 'Test Subj',
      toAddresses: 'test@123.com,test@345.com',
    },
  ];

  postInvigilator_s2_Data(payload2)
    .then((res) => {
      console.log('response send mail', res);
    })
    .catch((err) => {
      console.log('Error', err);
    });
  return console.log('send mail box');
};


/* EXAM DASHBOARD */
export const sendMailExamData = () => {
  const payload2 = {
    subject: 'Test Subj',
    body: 'Test Subj',
    toAddresses: 'test@123.com,test@345.com',
  };

  // alert('Annnouncements done');
  //api integration is pending

  /* postInvigilator_s2_Data(payload2)
      .then((res) => {
        console.log('response send mail', res);
      })
      .catch((err) => {
        console.log('Error', err);
      }); */
  return console.log('send mail box');
};
/* STUDENT STATUS */
export const sendMailStudentStatus = () => {
  const payload2 = [
    {
      sendEmail: true,
      subject: 'Test Subj',
      body: 'Test Subj',
      toAddresses: 'test@123.com,test@345.com',
    //   base64Attachment: 'GARFWVJHVHAVJHFYFYAFFSJ-JIOSHJIGUJS',
    },
  ];

  postStudentStatusData(payload2)
    .then((res) => {
      console.log('response send mail', res);
    })
    .catch((err) => {
      console.log('Error', err);
    });
  return console.log('send mail box');
};
